var React = require('react');

function Rhombus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M808,553.91c3.936,8.371,7.759,16.692,11.613,25.09h0c6.12-6.7,12.345-13.353,18.387-20.022h0c-3.39-8.3-6.807-16.677-10.2-24.978h0C821.219,540.6,814.584,547.307,808,553.91Z","transform":"translate(-808 -534)","fill":"currentColor","fillRule":"evenodd"}));
}

Rhombus.defaultProps = {"width":"30","height":"45","viewBox":"0 0 30 45"};

module.exports = Rhombus;

Rhombus.default = Rhombus;
